<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import tubeSamples from './14-Products-redesigned-Product-Samples.png';

	// images
</script>

<Section backgroundColor="blue">
	<div
		class="
    grid grid-flow-row place-items-center gap-8 gap-y-4
    md:grid-flow-col md:grid-cols-[auto_1fr]
  "
	>
		<Image
			src={tubeSamples}
			alt="Indow window insert compression tube color samples."
			class="h-auto max-w-96"
		/>

		<div>
			<h2>Customize Your Insert</h2>
			<p
				class="
      text-center
      md:text-left
    "
			>
				Each insert has a tube that edges the clear acrylic. This tubing should
				blend into your window frame. It comes in three colors: white, brown,
				and black.
			</p>
			<p
				class="
      text-center
      md:text-left
    "
			>
				All our acrylic interior storm windows are durable, lightweight and made
				to blend seamlessly with the surrounding frame. Don't buy new windows.
				Make the ones you have just right with our precision measuring software,
				which will ensure a tight fit for your new window inserts. Just choose
				the grade you need and get started measuring. We're here to help at
				every step.
			</p>
		</div>
	</div>
</Section>
